module.exports = __webpack_public_path__ + "static/media/photo_design.7294d56a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SideImage/photo_design.jpg
// module id = 389
// module chunks = 0